<template>
  <div class="party-body">
    <div class="explain-box">
      <p>乡镇/村党员人数分布统计图</p>
      <p>总注册党员人数：{{allPeople}}人</p>
      <p>（点击乡镇条形图查看具体村人数分布）</p>
    </div>
    <div class="area-dispered-title">
      <p>区域分布</p>
      <p v-if="choosed!=''">
        {{choosed}}
        <span>{{peopleNums}}人</span>
      </p>
      <button v-if="choosed!=''" @click="back">返回上级</button>
    </div>

    <div class="area-box">
      <div class="area-template" v-for="data in datas" :key="data.name">
        <div>
          <p v-text="data.name"></p>
          <p>{{data.people}}人</p>
          <p @click="goDetail(data)" v-show="state">查看详情</p>
        </div>
        <div>
          <p>所占百分比</p>
          <p class="color" v-text="data.persent"></p>
          <p>
            <span class="color" :style="{'width':data.persent}"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      peopleNums: "",
      allPeople: "",
      datas: [],
      choosed: ""
    };
  },
  methods: {
    goDetail(town) {
      this.choosed = town.name;
      this.peopleNums = town.people;
      this.state=false
      this.axios
        .post("/api/Statistics/Details", {
          c2name: sessionStorage.getItem("token"),
          c2town: town.name
        })
        .then(e => {
          console.log(e.data);
          this.datas = [];
          switch (e.data.code) {
            case 0:
              let Temp = e.data.msg;
              let num = 0
              Temp.filter(item => {
                num+=item.TownCount
                this.datas.push({
                  name: item.Town,
                  people: item.TownCount,
                  persent:
                    Math.round((item.TownCount / this.peopleNums) * 10000) /
                      100 +
                    "%"
                });
              });
              // alert(num);
              
              break;

            default:
              break;
          }
        });
    },
    back() {
      this.peopleNums = this.choosed = "";
      this.state=true
      this.getMsg();
    },
    getMsg() {
      let c2town;
      if (sessionStorage.getItem("roleid") == "2") c2town = "东坡区";
      else c2town = sessionStorage.getItem("town");
      this.axios
        .post("/api/Statistics/TotalNum", {
          c1roleid: sessionStorage.getItem("roleid"),
          c2name: sessionStorage.getItem("token"),
          c2town: c2town
        })
        .then(e => {
          this.datas = [];
          console.log(e.data);

          switch (e.data.code) {
            case 0:
              let Temp = e.data.msg;
              Temp.filter(item => {
                this.datas.push({
                  name: item.Town,
                  people: item.TownCount,
                  persent:
                    Math.round((item.TownCount / this.allPeople) * 10000) /
                      100 +
                    "%"
                });
              });

              break;

            default:
              break;
          }
        });
    },
  },
  mounted() {
    if(sessionStorage.getItem('roleid')=='2') this.state = true
    else this.state = false
    this.allPeople = this.$route.query.allPeople;
    this.getMsg();
  }
};
</script>
<style lang='scss' scoped>
.party-body {
  .area-box {
    .area-template {
      div {
        &:nth-child(1) {
          p {
            &:nth-child(1) {
              font-size: 0.32rem;
              margin-right: 0.2rem;
            }
            &:nth-child(2) {
              color: #e70303;
            }
            &:nth-child(3) {
              text-decoration: underline;
              color: #1095fc;
              margin-left: auto;
            }
          }
        }
        &:nth-child(2) {
          p {
            &:nth-child(1) {
              color: #999999;
              font-size: 0.22rem;
              white-space: nowrap;
            }
            &:nth-child(2) {
              padding: 0.05rem 0.1rem;
              font-size: 0.22rem;
              color: #fff;
              margin: 0 0.2rem 0 0.1rem;
              border-radius: 0.08rem;
            }
            &:nth-child(3) {
              span {
                display: inline-block;
                height: 0.08rem;
                position: absolute;
                left: 0;
                width: 0;
                transition: width 1s;
              }

              width: 80%;
              background: rgba($color: #dddddd, $alpha: 0.2);
              border-radius: 0.03rem;
              height: 0.08rem;
              position: relative;
            }
            text-align: center;
          }
          margin-top: 0.2rem;
        }
        display: flex;
        align-items: center;
      }
      &:nth-child(6n-5) {
        .color {
          background: #1095fc;
        }
      }
      &:nth-child(6n-4) {
        .color {
          background: #f7a35c;
        }
      }
      &:nth-child(6n-3) {
        .color {
          background: #f45b5b;
        }
      }
      &:nth-child(6n-2) {
        .color {
          background: #8085e9;
        }
      }
      &:nth-child(6n-1) {
        .color {
          background: #91e8e1;
        }
      }
      &:nth-child(6n) {
        .color {
          background: #2b908f;
        }
      }
      width: 94%;
      margin: 0.3rem auto;
      border-radius: 0.08rem;
      box-shadow: 0px 0.04rem 0.16rem 0px rgba(0, 0, 0, 0.08);
      padding: 0.2rem;
    }
  }
  .area-dispered-title {
    p {
      &:nth-child(1) {
        margin-right: 0.2rem;
      }

      &:nth-child(2) {
        font-weight: bold;
        span {
          color: #eb4242;
        }
      }
    }
    button {
      border: none;
      margin-left: auto;
      color: #fff;
      padding: 0.1rem 0.2rem;
      border-radius: 0.08rem;
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
    }
    .choose-button {
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
    }
    padding: 0 0.4rem;
    line-height: 3;
    display: flex;
    align-items: center;
  }
  .explain-box {
    p {
      &:nth-child() {
        font-size: 0.32rem;
        color: #ffa000;
      }
      &:nth-child(2) {
        font-size: 0.26rem;
      }
      &:nth-child(3) {
        color: #999999;
        font-size: 0.24rem;
      }
    }
    text-align: center;
    padding: 0.2rem 0;
    width: 94%;
    margin: 0.2rem auto;
    box-shadow: 0px 0.06rem 0.16rem 0px rgba(0, 0, 0, 0.08);
    border-radius: 0.08rem;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
  background: #fff;
}
</style>